module.exports = __webpack_public_path__ + "img/login-icon.50ffa5f1.svg";